import React, {Component} from "react";
import PropTypes from "prop-types";
import {apiUrl} from "../config/apiUrl";
import Loading from "../../lib/steps_components/common/Loading";
import {getSessionId} from "../utils/sessionmanagement";


class DunzoConfirmDetailComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Initially, no file is selected
            mobileNo: this.props.mobileNo,
            candidateName: this.props.candidateName,
            candidateNameError: null,
            mobileNumberError: null,
            confirmButtonClicked: false
        }
    }

    checkInputValidation = () => {
        if (!this.state.candidateName) {
            this.setState({candidateNameError: 'Please Enter your Name'})
            return false
        }

        if (!(this.state.candidateNameError === null) && !(this.state.lastNameError === null) && !(this.state.mobileNumberError === null)) {
            return false
        }
        return true
    }
    onConfirmButtonClick = () => {
        if (this.checkInputValidation() && !this.state.confirmButtonClicked) {
            this.setState({confirmButtonClicked: true});
            let url = `${apiUrl}candidate-response/`;
            let body = {
                "session_id": getSessionId(),
                "chat_identifier": this.props.chatFormIdentifier,
                "identifier": this.props.identifier,
                "identifier_type": this.props.identifierType,
                "type": this.props.type,
                "refer_candidate_api": true,
                "response": {
                    "candidate_name": this.state.candidateName,
                    "mobile_no": this.state.mobileNo
                }
            };
            fetch(url, {
                method: "post",
                body: JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(res => res.json())
                .then(dataReceived => {
                    this.props.triggerNextStep();
                })
        }
    };

    render() {
        return (
            <div>
                <div> Check Your Details below which will be used to create your Dunzo Account/ನಿಮ್ಮ DUNZO ಖಾತೆಯನ್ನು ರಚಿಸಲು ಬಳಸಲಾಗುವ ನಿಮ್ಮ ವಿವರಗಳನ್ನು ಕೆಳಗೆ ಪರಿಶೀಲಿಸಿ</div>
                {/*{this.fileData()}*/}
                <div>
                    <div style={{marginTop: "15px", textAlign: 'left', marginBottom: '2px'}}><label htmlFor="candidateName">Candidate Name</label>
                    </div>
                    <div style={{textAlign:'left'}}>
                        <input
                            id={"candidateName"}
                            type="text"
                            autoFocus
                            value={this.state.candidateName}
                            onChange={(e) => {
                                this.setState({candidateName: e.target.value})
                                if (!e.target.value.trim()) {
                                    this.setState({candidateNameError: 'Please Enter your Name'})
                                } else {
                                    this.setState({candidateNameError: null})
                                }
                            }
                            }
                            style={{
                                marginBottom: "10px",
                                background: "white",
                                color: "black",
                                maxWidth: "100%",
                                borderRadius: "5px"
                            }}
                        />
                    </div>
                    {this.state.candidateNameError ? <div style={{color: 'red'}}>{this.state.candidateNameError}</div> : null}
                    <div style={{textAlign: 'left', marginBottom: '2px'}}><label htmlFor="mobileNo">Mobile No</label>
                    </div>
                    <div style={{textAlign:'left'}}>
                        <input
                            id={"mobileNo"}
                            type="text"
                            disabled={true}
                            value={this.state.mobileNo}
                            onChange={(e) => {
                                const mobileNumber = e.target.value;
                                this.setState({mobileNo: mobileNumber})
                                this.setState({mobileNumberError: null})
                            }
                            }
                            style={{
                                marginBottom: "10px",
                                background: "white",
                                color: "black",
                                maxWidth: "100%",
                                borderRadius: "5px"
                            }}
                        />
                    </div>
                    {this.state.mobileNumberError ?
                        <div style={{color: 'red'}}>{this.state.mobileNumberError}</div> : null}
                    <div><br/></div>
                    <button onClick={this.onConfirmButtonClick} style={{background: "white", borderRadius: "5px"}}>
                        Confirm
                    </button>
                </div>
                {this.state.loading && this.state.uploadClicked ? <Loading/> : null}
            </div>
        );
    }
}

DunzoConfirmDetailComponent.propTypes = {
    steps: PropTypes.object,
};

DunzoConfirmDetailComponent.defaultProps = {
    steps: undefined,
};

export default DunzoConfirmDetailComponent;
